
define('hbs!glu/grid/sectionLayout.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    return "static-width-table-layout";
},"3":function(depth0,helpers,partials,data) {
    return "    <section class=\"loader grid-loader hidden\"></section>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<section class=\"header\" data-region=\"header\"></section>\n<section class=\"manage-columns\" data-region=\"manageColumns\"></section>\n<section class=\"content "
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.disableDynamicColumnWidths : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\" data-region=\"content\"></section>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.showLoaderOnFilter : depth0),{"name":"if","hash":{},"fn":this.program(3, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "<section class=\"footer\" data-region=\"footer\"></section>\n";
},"useData":true});Handlebars.registerPartial('glu/grid/sectionLayout.hbs', t);return t;});
